import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  handleMicrosoftSsoRedirect,
  resolveAuthErrorMessage,
  setMicrosoftSsoRedirectError,
} from "./microsoftSsoRedirect.js";

const MicrosoftSsoRedirectHandler = ({
  api,
  completeLogin,
  onRedirectFinished,
}) => {
  const history = useHistory();
  const { t } = useTranslation();
  const completeLoginRef = useRef(completeLogin);
  const onRedirectFinishedRef = useRef(onRedirectFinished);
  const tRef = useRef(t);

  completeLoginRef.current = completeLogin;
  onRedirectFinishedRef.current = onRedirectFinished;
  tRef.current = t;

  useEffect(() => {
    let isMounted = true;

    const finishRedirectHandling = () => {
      onRedirectFinishedRef.current?.();
    };

    handleMicrosoftSsoRedirect({
      api,
      onSuccess: async (userData) => {
        if (!isMounted) {
          return;
        }

        await completeLoginRef.current(userData);

        if (window.location.pathname === "/login") {
          history.replace("/");
        }
      },
      onError: (error, message) => {
        if (!isMounted || error?.errorCode === "user_cancelled") {
          return;
        }

        const resolved =
          resolveAuthErrorMessage(error, tRef.current) ||
          message ||
          error?.message ||
          "";
        setMicrosoftSsoRedirectError(resolved);

        console.error(
          "Microsoft sign-in failed:",
          resolved || error?.errorCode || error?.message || "unknown",
        );
      },
    }).finally(() => {
      if (isMounted) {
        finishRedirectHandling();
      }
    });

    return () => {
      isMounted = false;
    };
  }, [api, history]);

  return null;
};

export default MicrosoftSsoRedirectHandler;
